export default "__VITE_ASSET__CRhk7Smy__"